import { render, staticRenderFns } from "./Subscripcion.vue?vue&type=template&id=80dca340"
import script from "./Subscripcion.vue?vue&type=script&lang=js"
export * from "./Subscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports